import React, { Component, Dispatch } from 'react';
import { IResetPasswordProps, IMyForgotPasswordQuestion } from '../../models/pages/login';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import * as Actions from '../../store/actions/login';
import { Input } from '../../components/input/text/main';
import Loading from '../../components/loading/loading';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
const T = Translator.create();

const _logger = Log.create('MyForgotPasswordQuestion page');
class MyForgotPasswordQuestion extends React.Component<IMyForgotPasswordQuestion> {
    public userName: string | null = null;
    public typedText: string | null = null;
    public refForm: HTMLFormElement | null = null;

    constructor(props: IMyForgotPasswordQuestion) {
        super(props);
    }

    public onBackClick = () => {
        this.props.dispatch(Actions.setCurrentPage('ResetPassword', ''));
    }

    public onLoginClick = () => {
        this.props.dispatch(Actions.setCurrentPage('Login', ''));
    }

    public onKeyUp = (event: any) => {
        event.preventDefault();
        if (event.keyCode === 13) {
            if (this.typedText) {
                this.setDispach(this.typedText);
            }
        }
    }

    public onChange = (event: string) => {
        this.typedText = event;
    }

    public onClickVerify = (event: any) => {
        event.preventDefault();
        if (this.typedText) {
            this.setDispach(this.typedText);
        }
    }

    public setDispach = (typedText: string) => {
        if (this.refForm && this.refForm.checkValidity()) {
            this.props.dispatch(Actions.myForgotPasswordQuestionAnswerGetAction(this.props.username!, typedText, 'myForgotPasswordQuestionAnswerGetAction', 'get'));
        }
    }

    public render() {
        return (
            <div>
                    <Loading spinnerId={'myForgotPasswordQuestionAnswerGetAction'} text={T.t('r_my_forgot_password_question_answer_loading_message')} />
                    {
                    (this.props.myForgotPasswordAnswerStatus) ?
                        (
                            <div className="row align-items-center" style={{ paddingTop: '13px' }}>
                                <h3> {T.t('r_my_forgot_password_question_answer_success_message')}</h3>
                                <div className="col">
                                    <br />
                                    <a onClick={this.onLoginClick}><i className="material-icons mr-3">keyboard_backspace</i> {T.t('r_my_forgot_password_success_login_btn')}</a>
                                </div>
                            </div>
                        ) :
                        (
                            <div className="animated fadeIn" >
                                <h5>{T.t('r_my_forgot_password_page_title')}</h5>
                                <p>{T.t('r_my_forgot_password_page_content_text')}</p>
                                <form ref={e => this.refForm = e}>
                                    <div>
                                        <div>{this.props.passwordSecurtiyQuestion}</div>
                                        <Input type="text"
                                            required={true}
                                            onChange={this.onChange}
                                            placeHolder={T.t('r_my_forgot_password_question_answer_input_placholder')}
                                            onkeyUp={this.onKeyUp}
                                            maxLenght={100}
                                            minLenght={1}
                                        />
                                    </div>
                                    <div className="row align-items-center" style={{ paddingTop: '13px' }}>
                                        <div className="col">
                                            <a onClick={this.onBackClick} className='d-flex align-items-center '><i className="material-icons mr-1">keyboard_backspace</i> {T.t('r_my_forgot_password_question_back')}</a>
                                        </div>
                                        <div className="col text-right">
                                            <button onClick={this.onClickVerify} className="btn btn-primary d-flex align-items-center gap-2">{T.t('r_my_forgot_password_question_verify_button')} <i className="material-icons">arrow_forward</i></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IResetPasswordProps) => {
    if (!state) {
        return ownProps;
    }
    // tslint:disable-next-line: one-variable-per-declaration
    const newProps: IResetPasswordProps = Object.assign({}, ownProps, {
        isQuestion: state.login.login.isQuestion,
        passwordSecurtiyQuestion: state.login.login.passwordSecurtiyQuestion,
        currentPage: state.login.login.currentPage,
        username: state.login.identitiy.userName,
        myForgotPasswordAnswerStatus: state.login.login.myForgotPasswordAnswerStatus,
        myForgotPasswordQuestionLoading: state.login.login.myForgotPasswordQuestionLoading
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.login.login === prev.login.login
    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => ({
    dispatch
});

const CMyForgotPasswordQuestion = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(MyForgotPasswordQuestion);

export default CMyForgotPasswordQuestion;
